import React from 'react'
import { Button, Modal } from 'semantic-ui-react'
import ContactForm from './ContactForm';
import '../styles/ContactModal.scss';
function ContactModal({isOpen, setIsOpen, trigger}) {
  const defaultTrigger = <Button size='massive' basic color='black' onClick={() => setIsOpen(!isOpen)}>30 Minute Consultation</Button>;

  return (
    <Modal
      onClose={() => setIsOpen(false)}
      onOpen={() => setIsOpen(true)}
      open={isOpen}
      closeIcon
      trigger={trigger || defaultTrigger}
    >
      <Modal.Header>
        <p className='modal-eyebrow'>Free Consultation</p>
        <h1 className='modal-title'>Let's Connect</h1>
        <p className='modal-subtitle'>Fill out the form below and I'll get back to you shortly.</p>
      </Modal.Header>
      <Modal.Content>
        <ContactForm fromModal={true} setIsOpen={setIsOpen}/>
      </Modal.Content>
    </Modal>
  )
}

export default ContactModal;
